export function getPlatform() {
  const agent = (navigator as any).userAgentData
  return agent?.platform ?? navigator.platform
}

const pt = (v: RegExp) => v.test(getPlatform())
const ua = (v: RegExp) => v.test(navigator.userAgent)
const vn = (v: RegExp) => v.test(navigator.vendor)

export const isTouchDevice = () => !!navigator.maxTouchPoints
export const isMac = () => (pt(/^mac/i) || ua(/mac/i)) && !isTouchDevice()
export const isAndroid = () => pt(/^android/i) || ua(/android|webos/i)
export const isApple = () =>
  pt(/mac|iphone|ipad|ipod/i) || ua(/mac|iphone|ipad|ipod/i)
export const isIOS = () => isApple() && !isMac()
export const isMobile = () => isIOS() || isAndroid()
export const isWindows = () =>
  pt(/^win/i) || ua(/win32|win64|windows|windows nt|wince/i)
export const isSafari = () => isApple() && vn(/apple/i)
export const isFirefox = () => ua(/firefox\//i)
export const isChrome = () => ua(/chrome\//i)
